<div
  class="premium-detail"
  [ngClass]="
    quoteDescription === 'Quote'
      ? hideAsterisk
        ? 'quote-new'
        : 'quote-new form-group required'
      : 'quote-current'
  "
>
  <h3 class="control-label">{{ quoteDescription }}</h3>
  <span class="currency">{{ quote.monthlyCost | currencyUSD }}</span>
  @if (quote.monthlyCost) {
    <span> <p>per month</p> </span>
  }
  <hr aria-hidden="true" />
  <p class="quote-term">{{ quote.fullCost | currencyUSD }} / {{ quote.policyTermMonths }}</p>
</div>
